export default __webpack_public_path__ + "static/media/2071.e4e7c43e.png";